import { MOMENT_TIME } from '../../momenttime';

var OTHER_COMMENT_DATA_MANAGER = {

    /**
     * 获取前端的他人批盘列表数据
     * @param {服务器返回他人批盘列表数据} listData 
     */
    getOtherCommentListByData(listData){
        var resultData = [];
        _(listData).forEach(function (data, index) {
            var timeArr = MOMENT_TIME.getTimeArrayByTimeStamp(data.f_time);
            var newData = {
                id: data.id,
                pipan: JSON.parse(data.pipan),
                timeText: timeArr[0] + '年' + timeArr[1] + '月' + timeArr[2] + '日',
                title: data.title,
                share: data.share,
                detailId: data.hid
            }
            resultData.push(newData);
        })
        return resultData;
    },

    /**
     * 修改前端他人批盘列表数据的他人批盘标题
     * @param {原来的列表数据} origiData 
     * @param {修改后的新数据} newData 
     */
    updateOtherCommentListDataTitle(origiData, newData) {
        origiData.forEach((data, index) => {
            if(data.id == newData.id) {
                data.title = newData.title
            }
        })
        return origiData;
    },

    /**
     * 删除前端他人批盘列表数据
     * @param {原来的列表数据} origiData 
     * @param {删除数据的id} dataId 
     */
    deleteOtherCommentListData(origiData, dataId) {
        origiData.forEach((data, index) => {
            if(data.id == dataId) {
                origiData.splice(index, 1)
            }
        })
        return origiData;
    }

}

export {
    OTHER_COMMENT_DATA_MANAGER
}